export default "__VITE_ASSET__08QLjAbZ__"